import { Component, OnInit } from '@angular/core';
import { IdentityService } from '../identity.service';

@Component({
  selector: 'app-logout',
  template: `
  <div class="card">
    <h1>Logout</h1>
    <p>Logout effettuato con successo. Chiudere la finestra del browser o cliccare <a [routerLink]="'/'">qui</a> per ricollegarsi.</p>
  </div>
  `
})

export class LogoutComponent implements OnInit {
  constructor(private identityService: IdentityService) { }

  ngOnInit(): void {
    this.identityService.logout();
  }
}
